var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWeather01D(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "56px",
    viewBox: "0 0 58 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-01d") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-01d",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.500000, 0.000000)",
    stroke: "#E3B505"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    fill: "#F5D547",
    strokeLinecap: "square",
    cx: 28.0787084,
    cy: 28.0787084,
    r: 15.0787084
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.25,0.5 L28.25,8.5 M37.1963305,1.90982848 L34.5917853,9.47397708 M45.199642,6.14923965 L40.2743502,12.4533257 M51.3919348,12.7584945 L44.6825702,17.1156068 M55.1016087,21.0208295 L47.3392429,22.9562047 M55.9263033,30.0401889 L47.9567457,29.342943 M53.7765392,38.8384027 L46.4681755,35.5845095 M48.8854263,46.4612719 L43.0345967,41.0052851 M41.7833869,52.0820556 L38.0276144,45.0184749 M33.2406328,55.0911354 L31.9891571,47.1896287 M24.2532114,55.1693526 L25.5046871,47.2678459 M15.6580869,52.3167914 L19.4138594,45.2532107 M8.45557288,46.8269488 L14.3064025,41.3709619 M3.42682915,39.2951754 L10.7351928,36.0412823 M1.11727456,30.5382863 L9.08683214,29.8410403 M1.77743037,21.5059774 L9.53979618,23.4413526 M5.33574573,13.1778298 L12.0451103,17.5349421 M11.4063527,6.45707038 L16.3316445,12.7611564 M19.3309102,2.07261256 L21.9354554,9.63676116",
    id: "Line",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeather01D);
export default __webpack_public_path__ + "static/media/icon-weather-01d.9c1d93d98c3ede6a77742d5c80b8b0e0.svg";
export { ForwardRef as ReactComponent };